
















































































import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import { showErrors } from '@/utils/snack'
import { tablePerPageOptions } from '@/utils/tablePerPageOptions'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { CarrierProduct } from '@/modules/CarrierProduct/interfaces/carrier-product'
import { policyStatus, policyStatusClass } from '@/modules/Policy/helpers/policy'
import FoldingCard from '@/components/FoldingCard.vue'
import AppTableDate from '@/components/AppTableDate.vue'
import PolicyDialog from '@/modules/Policy/scripts/policy-dialog'
import { getPolicies } from '@/modules/Policy/gql/policy.gql'
import { ApolloResponse } from '@/interfaces/apollo'
import dollarFilter from '@/utils/dollarFilter'

@Component({
  components: {
    FoldingCard,
    AppTableDate
  }
})
export default class CarrierProductDetailPolicy extends mixins(PolicyDialog) {
  @Prop({ type: Object as () => CarrierProduct }) readonly carrierProduct!: CarrierProduct

  policies: Policy[] = []

  orderBy: {
    [key: string]: string
  } = {
    id: 'ID',
    policyNumber: 'POLICY_NUMBER',
    policyName: 'POLICY_NAME',
    effectiveDate: 'EFFECTIVE_DATE',
    expirationDate: 'EXPIRATION_DATE',
    status: 'POLICY_STATUS'
  }

  dollarFilter = dollarFilter

  tableColumn = [
    { field: 'policyNumber',
      title: 'Policy Number',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.policyNumber ? row.policyNumber : '-')
        ]
      }
      },
      sortable: true,
      resizable: true },
    { field: 'policyName',
      title: 'Policy Name',
      slots: { default: 'name_default' },
      resizable: true,
      sortable: true,
      width: 400
    },
    {
      field: 'status',
      title: 'Status',
      slots: { default: 'status_default' },
      sortable: true,
      resizable: true
    },
    { title: 'Carrier',
      field: 'carrier',
      slots: { default: 'carrier_name_default' },
      resizable: true
    },
    { title: 'Premium',
      field: 'premium',
      slots: { default: 'premium_default' },
      resizable: true,
      with: 100
    },
    { title: 'Effective Date',
      field: 'effectiveDate',
      slots: {
        default: 'effective_default'
      },
      resizable: true,
      sortable: true
    },
    { title: 'Expiration Date',
      field: 'expirationDate',
      slots: {
        default: 'expiration_default'
      },
      sortable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  tableOptions = {
    loading: false,
    tablePage: tablePerPageOptions(),
    sortBy: 'name',
    sortDesc: true
  }

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay

  policyStatus = policyStatus
  policyStatusClass = policyStatusClass

  @Emit('refresh')
  onSuccess () {
    // do nothing
  }

  @Watch('carrierProduct', { deep: true })
  onCarrierProductUpdated () {
    this.getPolicies()
  }

  mounted () {
    this.getPolicies()
  }

  routeToDetail (item: any) {
    return {
      name: 'PolicyDetailDetail',
      params: {
        id: item.id
      }
    }
  }

  routeToCarrierDetail (item: any) {
    return {
      name: 'CarrierDetailDetail',
      params: {
        id: item.carrier.id
      }
    }
  }

  async getPolicies () {
    const { sortBy, sortDesc, tablePage } = this.tableOptions
    const { currentPage, pageSize } = tablePage
    const orderBy = this.orderBy[sortBy] || 'UPDATED_AT'
    this.tableOptions.loading = true
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getPolicies,
        variables: {
          filter: {
            carrierProductId: Number(this.carrierProduct.id)
          },
          order: {
            orderBy: orderBy,
            asc: !sortDesc
          },
          paging: {
            offset: (currentPage - 1) * pageSize,
            limit: pageSize
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.policies = result.data.getPolicies.policies
      this.tableOptions.loading = false
      this.tableOptions.tablePage.total = result.data.getPolicies.paging.totalCount
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  sortTable (column: any) {
    this.tableOptions.sortBy = column.property
    this.tableOptions.sortDesc = column.order === 'desc'
    this.getPolicies()
  }

  handlePageChange (pageData: any) {
    this.tableOptions.tablePage.currentPage = pageData.currentPage
    this.tableOptions.tablePage.pageSize = pageData.pageSize
    this.getPolicies()
  }

  async deletePolicyConfirm () {
    await this.deletePolicyPost()
    this.onSuccess()
  }
}
